/**
 * Generated template index
 * This file is auto-generated by scripts/generate-templates.js
 * DO NOT EDIT MANUALLY
 */

import { TierListTemplate } from "@/types/tier-list";
import * as classic from "./classic";
import * as food from "./food";
import * as gaming from "./gaming";
import * as hvh_gear from "./hvh-gear";
import * as hvh_hero_weapons from "./hvh-hero-weapons";
import * as hvh_heroes from "./hvh-heroes";
import * as hvh_pets from "./hvh-pets";
import * as hvh_weapons from "./hvh-weapons";
import * as movies from "./movies";
import * as simple_ranking from "./simple-ranking";

/**
 * All template metadata (available immediately)
 */
export const TEMPLATE_METADATA = [
  classic.metadata,
  food.metadata,
  gaming.metadata,
  hvh_gear.metadata,
  hvh_hero_weapons.metadata,
  hvh_heroes.metadata,
  hvh_pets.metadata,
  hvh_weapons.metadata,
  movies.metadata,
  simple_ranking.metadata,
];

/**
 * Load full template by ID
 */
export async function loadTemplate(id: string): Promise<TierListTemplate> {
  switch (id) {
    case "classic":
      return classic.loadFull();
    case "food":
      return food.loadFull();
    case "gaming":
      return gaming.loadFull();
    case "hvh-gear":
      return hvh_gear.loadFull();
    case "hvh-hero-weapons":
      return hvh_hero_weapons.loadFull();
    case "hvh-heroes":
      return hvh_heroes.loadFull();
    case "hvh-pets":
      return hvh_pets.loadFull();
    case "hvh-weapons":
      return hvh_weapons.loadFull();
    case "movies":
      return movies.loadFull();
    case "simple-ranking":
      return simple_ranking.loadFull();
    default:
      throw new Error(`Template with id "${id}" not found`);
  }
}

/**
 * Get template metadata by ID
 */
export function getTemplateMetadata(id: string) {
  return TEMPLATE_METADATA.find((t) => t.id === id);
}
